import Footer from "../components/Footer";

export default function Sitemap() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="text-2xl font-bold">Plan du site</h1>
        <ul className="mt-3 list-disc pl-5 space-y-1">
          {[
            ["/", "Accueil"],
            ["/features", "Fonctionnalités"],
            ["/pricing", "Tarifs"],
            ["/faq", "FAQ"],
            ["/contact", "Contact"],
            ["/content/new", "Nouveau contenu"],
            ["/contents", "Mes contenus"],
            ["/projects", "Projets"],
            ["/personas", "Personas"],
            ["/writers", "Rédacteurs"],
            ["/settings", "Réglages"],
          ].map(([to, label]) => (
            <li key={to}>
              <a className="underline" href={to as string}>{label}</a>
            </li>
          ))}
        </ul>
      </main>
      <Footer />
    </div>
  );
}
